import { useState } from 'react'

/**
 * Persists the user's pinned table column. `undefined` means the user hasn't chosen yet
 * (the table falls back to its default); `null` means they unpinned everything.
 */
export function usePinnedColumn(storageKey: string): {
  pinnedColumnId: string | null | undefined
  onPinnedColumnChange: (nextPinnedColumnId: string | null) => void
} {
  const [pinnedColumnId, setPinnedColumnId] = useState<string | null | undefined>(() => {
    try {
      const stored = localStorage.getItem(storageKey)
      if (stored !== null) {
        const parsed: unknown = JSON.parse(stored)
        if (parsed === null || typeof parsed === 'string') return parsed
      }
    } catch {
      // corrupt JSON or storage unavailable — fall through to default
    }
    return undefined
  })

  function onPinnedColumnChange(nextPinnedColumnId: string | null) {
    setPinnedColumnId(nextPinnedColumnId)
    try {
      localStorage.setItem(storageKey, JSON.stringify(nextPinnedColumnId))
    } catch {
      // storage may be unavailable (private mode, quota); pinning still works in-memory
    }
  }

  return { pinnedColumnId, onPinnedColumnChange }
}
